

const ms101e = {
  label: "Customer Explorer",
  pageLabel: "Customer Explorer",
  starting: true,
  url: "ms101e",
  pageType: "history",
  form: [
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Branch",
      label: "Parent Branch",
      name: "",
      description: "Enter Branch"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "branch-1",
          value: "branch-1"
        },
        {
          label: "branch-2",
          value: "branch-2"
        },
        {
          label: "branch-3",
          value: "branch-3"
        }
      ],
      placeHolder: "Branch Code",
      //   label: "Branch Code",
      name: "filterBranch",
      description: "Enter branch code"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "branch",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Risk Type",
      label: "Risk Type",
      name: "",
      description: "Enter Risk Type"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "risk type-1",
          value: "risk type-1"
        },
        {
          label: "risk type-2",
          value: "risk type-2"
        },
        {
          label: "risk type-3",
          value: "risk type-3"
        }
      ],
      placeHolder: "Risk Type",
      //   label: "Branch Code",
      name: "riskType",
      description: "Enter Risk Type"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Customer Type",
      label: "Customer Type",
      name: "branch",
      description: "Select Customer Type"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "indivisual",
          value: "indivisual"
        },
        {
          label: "internal",
          value: "internal"
        },
        {
          label: "Other",
          value: "Other"
        }
      ],
      placeHolder: "Customer Type",
      //   label: "Branch Code",
      name: "Customertype",
      description: "Select Customer Type"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "Customertype",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "TDS Flag",
      label: "TDS Flag",
      name: "branch",
      description: "Select TDS Flag"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "tds-flag-1",
          value: "tds-flag-1"
        },
        {
          label: "tds-flag-2",
          value: "tds-flag-2"
        },
        {
          label: "tds-flag-3",
          value: "tds-flag-3"
        }
      ],
      placeHolder: "TDS Flag",
      //   label: "Branch Code",
      name: "tdsGlag",
      description: "Select TDS Flag"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Customer No",
      label: "Customer No",
      name: "",
      description: "Select Customer No"
    },
    {
      inputType: "autocomplete",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "customer-1",
          value: "customer-1"
        },
        {
          label: "customer-2",
          value: "customer-2"
        },
        {
          label: "customer-3",
          value: "customer-3"
        }
      ],
      placeHolder: "Customer Number",
      //   label: "Branch Code",
      name: "CustomerNo",
      description: "Select Customer number"
    },
    {
      inputType: "showdata",
      tab: "filter",
      data: "CustomerNo",
      textcolor: "black",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      }
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Sort By",
      label: "Sort By",
      name: "branch",
      description: "Select Sort By"
    },
    {
      inputType: "select",
      tab: "filter",
      default: "",
      elementProps: {
        stayOpen: false,
        removeSelected: true,
        disabled: false,
        rtl: false
      },
      widths: {
        parent: "col-sm-3",
        children: "col-sm-12"
      },
      ajaxLoad: true,
      ajaxOptions: {
        value: "code",
        label: "descn",
        query: {
          dialect: "mysql",
          query: "getRegionCode"
        }
      },
      options: [
        {
          label: "sort by-1",
          value: "sort by-1"
        },
        {
          label: "sort by-2",
          value: "sort by-2"
        },
        {
          label: "sort by-3",
          value: "sort by-3"
        }
      ],
      placeHolder: "Sort By",
      //   label: "Branch Code",
      name: "sortBy",
      description: "Select Sort By"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Name",
      label: "Name",
      name: "",
      description: "Enter Name"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Name",
      label: "",
      name: "Name",
      description: "Enter Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "First Name",
      label: "First Name",
      name: "",
      description: "Enter First Name"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter First Name",
      label: "",
      name: "FirstName",
      description: "Enter First Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Last Name",
      label: "Last Name",
      name: "",
      description: "Enter Last Name"
    },
    {
      inputType: "text",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Last Name",
      label: "",
      name: "filterLastName",
      description: "Enter Last Name"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Number Of Records",
      label: "Number Of Records",
      name: "",
      description: "Enter Number Of Records"
    },
    {
      inputType: "numberonly",
      tab: "filter",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter Number Of Records",
      label: "",
      name: "numberOfRecords",
      description: "Enter Number Of Records"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "PAN",
      label: "PAN",
      name: "",
      description: "Enter PAN"
    },
    {
      inputType: "text",
      tab: "filter",
      // validations: [{ rule: panCardNumber, message: "PAN number is INVALID" }],
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter PAN",
      label: "",
      name: "pan",
      description: "Enter PAN"
    },
    {
      inputType: "displaytext",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "AADHAR",
      label: "AADHAR",
      name: "",
      description: "Enter AADHAR"
    },
    {
      inputType: "numberonly",
      tab: "filter",

      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Enter AADHAR",
      label: "",
      name: "aadhaar",
      description: "Enter AADHAR"
    },
    {
      inputType: "checkbox",
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Current Year Balances",
      label: "Current Year Balances",
      name: "active",
      description: "Current Year Balances"
    },
    {
      inputType: "checkbox",
      default: true,
      tab: "filter",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "active",
      description: "Active"
    }
  ],
  history: {
    perPage: 10,
    reportHeader: "User Statement",
    pdfProps: { pageSize: "A4", pageOrientation: "portrait" },
    displayColumns: [
      {
        Header: "Branch",
        accessor: "LoginName",
        width: 150
      },
      {
        Header: "Customer No.",
        accessor: "lastname",
        width: 150
      },
      {
        Header: "Risk",
        accessor: "email"
      },
      {
        Header: "TDS Flag",
        accessor: "mobile"
      },
      {
        Header: "Title",
        accessor: "pfnumber"
      },
      {
        Header: "Full Name",
        accessor: "EmployeeID"
      },
      {
        Header: "Last Name",
        accessor: "EmployeeID"
      },
      {
        Header: "first Name",
        accessor: "EmployeeID"
      },
      {
        Header: "DOB",
        accessor: "EmployeeID"
      },
      {
        Header: "PAN",
        accessor: "EmployeeID"
      },
      {
        Header: "AADHAAR",
        accessor: "EmployeeID"
      }
    ]
  }
};

export default ms101e;
